// 保险 H5 接口封装（对接 yudao member 模块）
// API 前缀取自环境变量 VUE_APP_API_BASE（见 .env / .env.development / .env.production）
// 开发环境默认 /api，由 vue.config.js 代理转发到后端；生产环境按需配置为实际域名前缀
const API_BASE = process.env.VUE_APP_API_BASE || ''

async function request(url, options = {}) {
  const res = await fetch(API_BASE + url, {
    headers: {
      'Content-Type': 'application/json'
    },
    ...options
  })
  const data = await res.json()
  // yudao 统一返回结构 { code, data, msg }，code=0 为成功
  if (data.code !== 0) {
    throw new Error(data.msg || '请求失败')
  }
  return data.data
}

// 获得保险返利配置（分页）
export function getRebatePage(params = {}) {
  const qs = new URLSearchParams(params).toString()
  return request(`/member/insurance-rebate/page?${qs}`)
}

// 创建保险表单（车险意向/返利记录）
export function createRecord(body) {
  return request(`/member/insurance-rebate-record/create`, {
    method: 'POST',
    body: JSON.stringify(body)
  })
}

// 上传图片（app 端文件上传接口，无需登录），返回图片 URL
export function uploadFile(file, directory = 'insurance') {
  const form = new FormData()
  form.append('file', file)
  if (directory) form.append('directory', directory)
  return fetch(API_BASE + '/infra/file/upload', {
    method: 'POST',
    body: form
  }).then(async (res) => {
    const data = await res.json()
    // yudao 统一返回结构 { code, data, msg }，code=0 为成功
    if (data.code !== 0) {
      throw new Error(data.msg || '上传失败')
    }
    return data.data
  })
}
